export const coreAddresses = {
  balanceTracker: "0x9842885CefC8Be5A913f804c39938F4531Bc5366",
  eVaultFactory: "0x4556a7b3507A0114E621DD761dBd2b505Ad07430",
  eVaultImplementation: "0xb1191195bC3a1B1C881310F70aAEB77ce36C5FEf",
  evc: "0x0311730613DF0C4c2e0284Bc34c951fb7567d56D",
  permit2: "0xA4Bf80b2CFBd80C00cB0Cc3d74C8762Ff4762770",
  protocolConfig: "0xcDd653FD0AEBa01c7A2a513741A5f6e4bD654595",
  sequenceRegistry: "0x91CB59e2a36571752b9F13372C4aADEfDF6e7738",
} as const
